import { Box, HStack, Image, Center, VStack, Button } from '@chakra-ui/react';
import { Mention, MentionsInput } from 'react-mentions';

import { extractName } from '../../../utils';
import { useTypedSelector } from '../../../hooks';
import { useGetTeamMembersQuery } from '../../../services';
import { useState } from 'react';

const prepareMentionedText = (text: string) => {
  const regex = /@\[(.*?)\]\(.*?\)/g;
  return text.replace(regex, '$1');
};

export const NewCommentInput = ({
  isDisabled,
  onSubmit,
}: {
  isDisabled: boolean;
  onSubmit: (text: string) => void;
}) => {
  const [text, setText] = useState('');
  const { userDetails } = useTypedSelector(state => state.auth);

  const { data: allUsers } = useGetTeamMembersQuery(
    {
      page: 0,
      size: 10000,
      companyId: Number(userDetails?.companyBasicInfo.id),
    },
    {
      skip: !userDetails,
    }
  );

  return (
    <VStack w="full" mt="4">
      <HStack w="full">
        <Box w="6" h="6" bg="custom_blue.1" borderRadius="full">
          {userDetails?.profilePictureThumbnailURL ? (
            <Image
              src={userDetails?.profilePictureThumbnailURL}
              borderRadius="full"
            />
          ) : (
            <Center h="full" color="white" textTransform="capitalize">
              {extractName(
                `${userDetails?.firstName} ${userDetails?.lastName}`
              )}
            </Center>
          )}
        </Box>

        <MentionsInput
          className="my-mentions-input"
          value={text}
          onChange={e => setText(e.target.value)}
        >
          <Mention
            className="mention-style"
            trigger="@"
            data={
              allUsers?.data.content.map(({ firstName, email }) => ({
                display: `@${firstName}`,
                id: email,
              })) || []
            }
            renderSuggestion={res => res.id}
          />
        </MentionsInput>
      </HStack>

      <Button
        bg="custom_orange.2"
        _hover={{ bg: 'custom_orange.2' }}
        color="white"
        fontWeight="semibold"
        fontSize="sm"
        alignSelf="flex-end"
        px="8"
        type="button"
        onClick={() => {
          onSubmit(prepareMentionedText(text));
          setText('');
        }}
        isDisabled={isDisabled}
      >
        Send
      </Button>
    </VStack>
  );
};
